import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    textAlign: 'left',
    font: 'normal normal normal 19px/27px Noto Sans TC',
    color: '#7C98CC',
  },
});

function LightTypography({ children }) {
  const classes = useStyles();

  return (
    <Typography classes={{ root: classes.root }} align="left">
      {children}
    </Typography>
  );
}

LightTypography.propTypes = {
  children: PropTypes.node,
};

LightTypography.defaultProps = {
  children: null,
};

export default LightTypography;
